import React from 'react';
import { Translation } from 'react-i18next';
import { Checkbox } from 'semantic-ui-react';

import fieldDecorator from 'components/dashboard/signup-generator-content/SignupGeneratorAppearence/fieldDecorator';

import './SignupGeneratorTermsSwitcher.css';

const SignupGeneratorTermsSwitcher = (props) => (
  <Translation>
    {(t) => (
      <div className="email-signup-generator-terms-switcher__component">
        <div className="email-signup-generator-terms-switcher-wrapper">
          <div className="email-signup-generator-terms-text-section">

            <div className="text-item">
              <h4>{t("Terms & Conditions (optional)")}</h4>
            </div>
          </div>

          <div className="switcher-wrapper">
            <span>{t("OFF")}</span>
            <Checkbox
              toggle
              {...props}
            />
            <span>{t("ON")}</span>
          </div>
        </div>
      </div>
    )}
  </Translation>
);

export default fieldDecorator(SignupGeneratorTermsSwitcher);
